(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoicePriceDeleteController',InvoicePriceDeleteController);

    InvoicePriceDeleteController.$inject = ['$uibModalInstance', 'entity', 'InvoicePrice'];

    function InvoicePriceDeleteController($uibModalInstance, entity, InvoicePrice) {
        var vm = this;

        vm.invoicePrice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InvoicePrice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
